<script setup lang="ts">
defineProps<{
  src: string;
  label: string;
  imageClass?: string;
}>()
</script>

<template>
  <div data-blob-img class="m-auto flex flex-col items-center">
    <NuxtImg
      data-blob-image
      :src="src"
      alt=""
      class="opacity-0"
      :class="[imageClass]"
    />
    <KUICoreCalloutLabel
      data-blob-label
      :text="label"
      class="opacity-0"
    />
  </div>
</template>
